import useNavigationParams from "@hooks/useNavigationParams";
import useTeamStandings from "@hooks/useTeamStandings";
import ErrorBoundaryComponent from "@components/core/modules/ErrorBoundaryComponent";

import TeamStandingsTable from "./TeamStandingsTable";
import StandingsWidgetSkeleton from "./StandingsWidgetSkeleton";

import SUPPORTED_COMPETITIONS from "@utils/SUPPORTED_COMPETITIONS";

const StandingsWidget = () => {
  const { searchParams } = useNavigationParams();

  const { standings, isLoadingStandings } = useTeamStandings(
    SUPPORTED_COMPETITIONS[searchParams.competition?.toLowerCase().trim()]
  );

  return (
    <ErrorBoundaryComponent>
      <StandingsWidgetSkeleton loading={isLoadingStandings} />
      {standings.length > 0 &&
        standings.map((group) => (
          <div key={group.name} style={{ marginBottom: 10 }}>
            <TeamStandingsTable title={group.name} standings={group.teams} />
          </div>
        ))}
    </ErrorBoundaryComponent>
  );
};

export default StandingsWidget;
